
/***mathjs***/
import * as mathjs from 'mathjs';
//加密
import CryptoJS from 'crypto-js';
import { message, Modal } from 'ant-design-vue'
import router from '@/router/index.js'
const key = CryptoJS.enc.Utf8.parse("zheDaUniv@202212");  //十六位十六进制数作为密钥

let base = {
  /***数字验证***/
  isNumberVerify(val) {
    var myReg = /^[0-9]+(\.\d+)?$/;
    if (!myReg.test(val)) {
      return false;
    } else {
      return true;
    }
  },
  /***姓名验证***/
  isNameVerify(name) {
    var myReg = /^(?:[\u4e00-\u9fa5]+)(?:●[\u4e00-\u9fa5]+)*$|^[a-zA-Z0-9]+\s?[\.·\-()a-zA-Z]*[a-zA-Z]+$/;
    if (!myReg.test(name)) {
      return false;
    } else {
      return true;
    }
  },
  //判断婚姻状态、国籍是否缺失-true-缺失，false-存在
  isMaritalStatusAndCountry() {
    if (sessionStorage.getItem("userInfo")) {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if ((userInfo.maritalStatus == 1 || userInfo.maritalStatus == 2 || userInfo.maritalStatus == 3) && userInfo.country) {
        return false;
      } else {
        Modal.warning({
          title: '温馨提示',
          content: '请更新个人信息',
          okText: "去更新",
          onOk() {
            router.push({
              path: '/myRegistration', query: {
                queryActived: 9,
                type: 'updateList'
              }
            });
          },
        });
      }
    }
  },
  //判断名单婚姻状态、国籍是否缺失-true-缺失，false-存在
  isMaritalStatusAndCountry2(memberInfo) {
    if (memberInfo) {
      let userInfo = memberInfo;
      if ((userInfo.maritalStatus == 1 || userInfo.maritalStatus == 2 || userInfo.maritalStatus == 3) && userInfo.country) {
        return false;
      } else {
        Modal.warning({
          title: '温馨提示',
          content: '请更新个人信息',
          okText: "去更新",
          onOk() {
            router.push({
              path: '/myRegistration', query: {
                queryActived: 9,
                type: 'updateList'
              }
            });
          },
        });
      }
    }
  },
  /**
   * 检查给定的对象是否为空。
   *
   * @param {Object} obj - 要检查的对象。
   * @returns {boolean} 如果对象为空，则返回true；否则返回false。
   */
  isEmpty(obj) {
    if (Object.keys(obj).length == 0) {
      return true;
    } else {
      return false;
    }
  },
  /***手机号验证***/
  isPoneAvailable(val) {
    //var myreg = /^\d{11}$/;
    var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (myreg.test(val)) {
      return true;
    } else {
      return false;
    }
  },
  /**身份证 */
  isCardVerify(card) {
    var myReg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (!myReg.test(card)) {
      return false;
    } else {
      return true;
    }
  },
  //根据身份证号获取出生日期
  getBirthdayByIdCard(idCard) {
    if (idCard) {
      let birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    } else {
      return "";
    }
  },
  //根据身份证号获取性别
  /**
   * 按身份证号码获取性别
   * @idNumber 身份证号码
   * @return 男：male；女：female；异常（身份证号码为空或长度、格式错误）：undefined
   */
  getGenderByIdNumber(idNumber) {
    if (idNumber) {
      let genderCode; // 性别代码
      if (idNumber.length == 18) {
        // 二代身份证号码长度为18位（第17位为性别代码）
        genderCode = idNumber.charAt(16);
      }
      if (genderCode && !isNaN(genderCode)) {
        // 两代身份证号码的性别代码都为男奇女偶
        if (parseInt(genderCode) % 2 == 0) {
          return 2;
        }
        return 1;
      }
    } else {
      return "";
    }
  },
  /**java使用sha1prng算法**/
  /***AES加密***/
  encryptAES(word) {
    var sContent = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(sContent, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },
  //解密
  decryptAES(word) {
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },

  /***时间转换***/
  timeSwitch(val, judge) {
    let date = new Date(val);
    let Month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let second = date.getSeconds();
    if (judge) {
      return date.getFullYear() + '-' + this.isTwo(Month) + '-' + this.isTwo(day) + ' ' + this.isTwo(hours) + ':' + this.isTwo(minutes) + ':' + this.isTwo(second);
    } else {
      return date.getFullYear() + '-' + this.isTwo(Month) + '-' + this.isTwo(day)
    }
  },
  isTwo(val) {
    if (val.toString().length > 1) {
      return val;
    } else {
      return '0' + val;
    }
  },
  //只显示月份
  showMonth(val) {
    let date = new Date(val);
    let Month = date.getMonth() + 1;
    return date.getFullYear() + '-' + this.isTwo(Month)
  },
  //只显示月日
  showMD(val) {
    if (val) {
      let date = new Date(val);
      let Month = date.getMonth() + 1;
      let Day = date.getDate();
      return this.isTwo(Month) + '-' + this.isTwo(Day);
    } else {
      return '-';
    }
  },
  //获取未来七天的年月日
  getSevenYMD(val) {
    let dateList = [];
    for (let index = 1; index < 8; index++) {
      let date = new Date(val);
      let Day = date.getDate();
      let num = Day + index;
      date.setDate(num);
      let Year = date.getFullYear();
      let Month = date.getMonth() + 1;
      let day = date.getDate();
      let dataItem = Year + '-' + this.isTwo(Month) + '-' + this.isTwo(day);
      dateList.push(dataItem);
    };
    return dateList;
  },
  //根据日期显示星期
  showWeek(val) {
    if (val) {
      let week = new Date(val).getDay();
      let result = "";
      switch (week) {
        case 1:
          result = "周一";
          break;
        case 2:
          result = "周二";
          break;
        case 3:
          result = "周三";
          break;
        case 4:
          result = "周四";
          break;
        case 5:
          result = "周五";
          break;
        case 6:
          result = "周六";
          break;
        default:
          result = "周日";
          break;
      };
      return result;
    } else {
      return '-';
    }
  },
  //根据出生日期计算年龄
  sumAge(value) {
    if (value) {
      let dateStr = value.toString().substring(0, 10);
      let ageDate = new Date(dateStr.replace(/\-/g, "/"));

      let currentYear = new Date().getFullYear();
      let currentMon = new Date().getMonth() + 1;
      let currentDate = new Date().getDate();
      let birthYear = new Date(ageDate).getFullYear();
      let birthMon = new Date(ageDate).getMonth() + 1;
      let birthDate = new Date(ageDate).getDate();
      let differ = currentYear - birthYear;
      if (birthMon > currentMon) {
        differ--;
      } else if (birthMon == currentMon) {
        if (birthDate > currentDate) {
          differ--;
        }
      }
      return differ;
    } else {
      return 0;
    }
  },
  /**yyyy-mm-dd 转成 时间戳 */
  getTimestamp(val) {
    if (val) {
      let date = new Date(val.replace(/\-/g, "/"));
      return date.getTime();
    }

  },

  //根据身份证号查年龄
  sumAgeByIdCard(idCard) {
    var date = new Date();
    if (idCard) {
      var currentYear = date.getFullYear();
      var currentMon = date.getMonth() + 1;
      var currentDate = date.getDate();
      var birthYear = idCard.substring(6, 10);
      var birthMon = idCard.substring(10, 12);
      var birthDate = idCard.substring(12, 14);
      var differ = currentYear - birthYear;
      if (birthMon > currentMon) {
        differ--;
      } else if (birthMon == currentMon) {
        if (birthDate > currentDate) {
          differ--;
        }
      }
      return differ;
    } else {
      return 0;
    }
  },
  /***隐私化姓名***/
  privacyName(e) {
    if (e) {
      var length = e.length - 1;
      var start = e.substring(0, 1);
      for (var i = 0; i < length; i++) {
        start = start + "*";
      }
      return start
    } else {
      return e;
    }
  },
  /***隐私化手机号***/
  privacyPhone(e) {
    if (e) {
      return e;
    }
    // if (e) {
    //   var start = e.substring(0, 3);
    //   var end = e.substring(7, 11);
    //   return start + "****" + end;
    // } else {
    //   return e;
    // }
  },
  /***隐私化身份证***/
  privacyIdCard(e) {
    if (e) {
      return e;
    }
    // if (e) {
    //   var start = e.substring(0, 6);
    //   var end = e.substring(14, 18);
    //   return start + "********" + end;
    // }
  },
  genderFormatter(e) {
    if (e == 1) {
      return "男";
    } else if (e == 2) {
      return "女";
    } else if (e == 3) {
      return "通用";
    } else {
      return '未知';
    }
  },
  //乘法 
  //parseFloat解决科学计数法
  accMul(arg1 = 0, arg2 = 0) {
    let value = mathjs.format(mathjs.multiply(mathjs.bignumber(arg1), mathjs.bignumber(arg2)));
    return parseFloat(value);
  },
  //除法
  accDiv(arg1 = 0, arg2 = 0) {
    let value = mathjs.format(mathjs.divide(mathjs.bignumber(arg1), mathjs.bignumber(arg2)));
    return parseFloat(value);
  },
  //加法
  accAdd(arg1 = 0, arg2 = 0) {
    let value = mathjs.format(mathjs.add(mathjs.bignumber(arg1), mathjs.bignumber(arg2)));
    return parseFloat(value);

  },
  //减法
  accSub(arg1 = 0, arg2 = 0) {
    let value = mathjs.format(mathjs.subtract(mathjs.bignumber(arg1), mathjs.bignumber(arg2)));
    return parseFloat(value);
  }

}
export default base;